<template>
  <div>
    <div class="relative">
      <div
        class="absolute left-4 sm:left-6 top-0 bottom-0 w-0.5 bg-linear-to-b/srgb from-blue-200 via-purple-200 to-gray-200"
      ></div>

      <div class="space-y-2 sm:space-y-3">
        <div v-for="(event, eventIdx) in displayedHistoricalData" :key="eventIdx" class="relative">
          <div class="absolute left-2 sm:left-4 top-2">
            <div class="group relative">
              <div
                :class="[
                  'w-3 h-3 sm:w-4 sm:h-4 rounded-full border-2 border-white shadow-xs transition-all duration-200',
                  getRelatedIconBackground(event.status),
                ]"
              >
                <component
                  :is="getRelatedIcon(event.status)"
                  class="w-1.5 h-1.5 sm:w-2 sm:h-2 text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                />
              </div>
              <div
                class="absolute -inset-1 sm:-inset-2 bg-blue-50 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              ></div>
            </div>
          </div>

          <div class="ml-8 sm:ml-12">
            <div
              class="bg-gray-50 hover:bg-gray-100 rounded-lg p-2 sm:p-3 transition-all duration-200 border border-gray-200 hover:border-gray-300"
            >
              <div class="flex items-center justify-between space-x-2 sm:space-x-3">
                <span class="uppercase text-xs font-light whitespace-nowrap">
                  {{ parseDate(event.date) ? $d(parseDate(event.date), "fullDateTime") : "" }}
                </span>
              </div>
              <div class="flex flex-col gap-2 sm:gap-0">
                <div class="flex-1 min-w-0">
                  <p class="text-xs sm:text-sm font-semibold text-blue-900 break-words">
                    {{ $t(`claim.status.${event.status}`) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Show more/less button -->
        <div v-if="hasMoreHistoricalData" class="relative">
          <div class="ml-8 sm:ml-12">
            <button
              @click="toggleShowAllHistoricalData"
              class="w-full bg-gray-50 hover:bg-gray-100 rounded-lg p-2 sm:p-3 transition-all duration-200 border border-gray-200 hover:border-gray-300 text-center"
            >
              <div class="flex items-center justify-center space-x-2">
                <span class="text-xs sm:text-sm font-medium text-gray-600">
                  {{
                    showAllHistoricalData
                      ? "Voir moins"
                      : `Voir ${claim.claimHistoricalDatas.length - 3} éléments de plus`
                  }}
                </span>
                <ChevronRightIcon :class="['w-3 h-3 sm:w-4 sm:h-4 text-gray-400 transition-transform duration-200']" />
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronRightIcon } from "@heroicons/vue/solid";
import { parseClaimDate, getClaimStatusIcon, getClaimStatusIconBackground } from "@estaly/ui";

export default {
  components: {
    ChevronRightIcon,
  },
  props: ["claim"],

  data: () => {
    return {
      showAllHistoricalData: false,
    };
  },

  computed: {
    displayedHistoricalData() {
      if (!this.claim?.claimHistoricalDatas) return [];

      if (this.showAllHistoricalData) {
        return this.claim.claimHistoricalDatas;
      }

      // Show only the first 3 items (most recent)
      return this.claim.claimHistoricalDatas.slice(0, 3);
    },

    hasMoreHistoricalData() {
      return this.claim?.claimHistoricalDatas?.length > 3;
    },
  },

  methods: {
    parseDate: parseClaimDate,
    getRelatedIcon: getClaimStatusIcon,
    getRelatedIconBackground: getClaimStatusIconBackground,

    toggleShowAllHistoricalData() {
      this.showAllHistoricalData = !this.showAllHistoricalData;
    },
  },
};
</script>
